/**
 * Onboarding Page - Main container for the e-learning flow
 *
 * Routes to individual modules based on current progress.
 * Handles navigation between steps and save/exit functionality.
 */

import { useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useOnboardingStore, useIsHardGateComplete } from '../stores/onboardingStore';
import OnboardingWizard from '../components/onboarding/OnboardingWizard';

export default function OnboardingPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { reset } = useOnboardingStore();
  const isHardGateComplete = useIsHardGateComplete();

  // Check if this is a delta onboarding (version update)
  const isDelta = location.state?.isDelta || false;
  const previousVersion = location.state?.previousVersion;

  // Allow forcing view of onboarding with ?preview=true or ?reset=true
  const isPreview = searchParams.get('preview') === 'true';
  const shouldReset = searchParams.get('reset') === 'true';

  // Handle reset request
  useEffect(() => {
    if (shouldReset) {
      reset();
      // Remove the reset param and reload
      window.location.href = '/onboarding';
    }
  }, [shouldReset, reset]);

  // Redirect to dashboard if already complete (unless delta flow or preview mode)
  useEffect(() => {
    if (isHardGateComplete && !isDelta && !isPreview && !shouldReset) {
      // User has completed hard gate, redirect to intended destination or dashboard
      const from = location.state?.from?.pathname || '/';
      navigate(from, { replace: true });
    }
  }, [isHardGateComplete, isDelta, isPreview, shouldReset, navigate, location.state]);

  return (
    <div
      className="min-h-screen"
      style={{
        backgroundColor: 'var(--color-bg)',
        color: 'var(--color-text-primary)',
      }}
    >
      <OnboardingWizard
        isDelta={isDelta}
        previousVersion={previousVersion}
      />
    </div>
  );
}
